
import styled from 'styled-components'

const Row = styled.div`
    display: flex;
    flex-direction: column;
`
const Column = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    align-items: center;
    @media (max-width:1050px){
        display: flex;
        flex-direction: column;
        img{
            margin: 0 auto;
            width: 90%;
            width: 50%;
        }
    }
`
const Title = styled.span`
    margin: .8em 0;
    font-style: normal;
    font-weight: bold;
    font-size: 36px;
    text-align: center;
    @media (max-width:600px){
    }
`
const Caption = styled.p`
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 33px;
    text-align: center;
    color: #3C3C3C;

    &.subtitle{
        margin: auto;
        max-width: 844px;
    }
    @media (max-width:844px){
        width: 90%;
        max-width: 95%;
    }
`

const MiniIcon = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 3em 0;
    h3{
        margin: .5em 0;
    }
    img{
        width: 28px;
    }
`
const LeftIconList = styled.div`
    display: flex;
    flex-direction: column;
    @media (max-width: 1050px) {
        display: none;
    }
`
const RightIconList = styled.div`
    display: flex;
    flex-direction: column;
    @media (max-width: 1050px) {
        display: none;
    }
`
const MobileIconList = styled.div`
    display: none;
    @media (max-width: 1050px) {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        overflow-x: scroll;
        max-width: 100%;
        margin-top: 3em;
    }
`
function Hero (props) {
  const { contents } = props
  return (
        <Row>
            <Title>{contents.homeHeroLabel}</Title>
            <Caption className="subtitle">
                {contents.homeHeroCaption}
            </Caption>
            <Column style={{ margin: '5em 0' }}>
                <LeftIconList>
                    { contents.homeHeroLeftList && contents.homeHeroLeftList.map(hero => (
                        <MiniIcon key={hero.label}>
                            <img src={hero.src} alt="" />
                            <h3>{hero.label}</h3>
                            <p style={{ textAlign: 'center', width: '300px', maxWidth: '600px', margin: '0 auto' }}>{hero.caption}</p>
                        </MiniIcon>
                    )) }
                </LeftIconList>
                {/* <img src={'/media/hero/mobile-apps.png'} alt="Mobile Apps" /> */}
                <img src={'/media/hero/mobile-apps.png'} style={{width: '431px', padding: '0 5px' }} alt="Mobile Apps" />
                <RightIconList>
                    { contents.homeHeroRightList && contents.homeHeroRightList.map(hero => (
                        <MiniIcon key={hero.label}>
                            <img src={hero.src} alt="" />
                            <h3>{hero.label}</h3>
                            <p style={{ textAlign: 'center', width: '300px', maxWidth: '600px', margin: '0 auto' }}>{hero.caption}</p>
                        </MiniIcon>
                    )) }
                </RightIconList>
                <MobileIconList>
                    { contents.homeHeroLeftList && contents.homeHeroLeftList.map(hero => (
                        <MiniIcon key={hero.label}>
                            <img src={hero.src} alt="" />
                            <h3>{hero.label}</h3>
                            <p style={{ textAlign: 'center', width: '200px', margin: '0 1em' }}>{hero.caption}</p>
                        </MiniIcon>
                    )) }
                    { contents.homeHeroRightList && contents.homeHeroRightList.map(hero => (
                        <MiniIcon key={hero.label}>
                            <img src={hero.src} alt="" />
                            <h3>{hero.label}</h3>
                            <p style={{ textAlign: 'center', width: '200px', margin: '0 1em' }}>{hero.caption}</p>
                        </MiniIcon>
                    )) }
                </MobileIconList>
            </Column>
        </Row>
  )
}

export default Hero
